import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

export interface ComiteCompromisosActaPayload {
  id?: number;
  numeroComite: number;
  numeroActa: number;
  compromiso: string;
  responsable: number;
  fecha: string | Date;
  avance: number;
  estado?: number;
  fechaCreacion?: string | Date;
  fechaModificacion?: string | Date | null;
}

export interface ComiteCompromisosActaResponse {
  message?: string;
  data?: ComiteCompromisosActaPayload | ComiteCompromisosActaPayload[];
  error?: string;
}

@Injectable({
  providedIn: 'root',
})
export class ComiteCompromisosActaService {
  private apiUrl = `${environment.apiUrl}/api/comiteCompromisosActa`;

  constructor(private http: HttpClient) {}

  getAll(): Observable<ComiteCompromisosActaResponse> {
    return this.http.get<ComiteCompromisosActaResponse>(this.apiUrl);
  }

  getById(id: number): Observable<ComiteCompromisosActaResponse> {
    return this.http.get<ComiteCompromisosActaResponse>(`${this.apiUrl}/${id}`);
  }

  getByActa(numeroComite: number, numeroActa: number): Observable<ComiteCompromisosActaResponse> {
    return this.http.get<ComiteCompromisosActaResponse>(`${this.apiUrl}/acta/${numeroComite}/${numeroActa}`);
  }

  create(payload: ComiteCompromisosActaPayload): Observable<ComiteCompromisosActaResponse> {
    return this.http.post<ComiteCompromisosActaResponse>(this.apiUrl, payload);
  }

  update(id: number, payload: Partial<ComiteCompromisosActaPayload>): Observable<ComiteCompromisosActaResponse> {
    return this.http.put<ComiteCompromisosActaResponse>(`${this.apiUrl}/${id}`, payload);
  }

  remove(id: number): Observable<ComiteCompromisosActaResponse> {
    return this.http.delete<ComiteCompromisosActaResponse>(`${this.apiUrl}/${id}`);
  }
}